import styled from "styled-components";
import { BaseScreenStyle } from "designer/ui/views/base-screen/base-screen-style";

export const ReferralScreenContainer = styled(BaseScreenStyle)`
    & .referral-link-section {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        span {
            margin-right: 12px;
            max-width: 100%;
            color: ${p => p.theme.fgColorMedium};
        }
    }
`;
